(function($, undefined) {
	'use strict';

	var initSlider = function() {
		$('.com-text-images').each(function() {
			var component = $(this);
			var slider = component.find('.text-images-pics-ctn');

			if (slider.find('.text-images-pic').length > 1) {
				slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				});
			}
		});
	};

	var init = function() {
		if ($('.text-images-pics-ctn').length > 0) {
			initSlider();
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
